import idLocale from 'element-ui/lib/locale/lang/id'
import home from './id/home'

const id = {
    language: 'Bahasa Indonesia',
    message: {
        'home': {
            ...home,
            enterEmail: 'Silakan masukkan email',
            save: 'Simpan',
            saveSuccess: 'Berhasil disimpan',
            pointHistory: 'Riwayat poin',
            type: 'Tipe',
            remark: 'Catatan',
            pendingComment: 'Menunggu ulasan',
            commented: 'Sudah diulas',
            selectDate: 'Pilih tanggal',
            loginSuccess: 'Login berhasil',
            loginFail: 'Login gagal',
            close: 'Tutup',
            required: 'Wajib',
            nickname: 'Nama panggilan',
            enterNickname: 'Silakan masukkan nama panggilan',
            gender: 'Jenis kelamin',
            male: 'Laki-laki',
            female: 'Perempuan',
            secret: 'Rahasia',
            birthday: 'Tanggal lahir',
            checkoutLoadFailed: 'Gagal memuat informasi pembayaran. Silakan coba lagi nanti.',
            checkoutErrorTitle: 'Pemberitahuan',
            goAddAddress: 'Tambah alamat pengiriman',
            shop_order_selectOrAddAddress: 'Silakan tambahkan alamat pengiriman terlebih dahulu dan jadikan default sebelum checkout.',
            shop_order_cartEmpty: 'Keranjang kosong, tidak dapat checkout.',
            shop_order_cartHasNotActive: 'Ada produk yang belum tayang atau tidak valid, tidak dapat checkout.',
            shop_order_cartHasNotMarketable: 'Ada produk yang sudah ditarik, tidak dapat checkout.',
            shop_order_cartHasLowStock: 'Stok tidak cukup, tidak dapat checkout.',
            shop_order_cartHasExpiredGoods: 'Beberapa produk toko sudah kedaluwarsa, tidak dapat checkout.',
            shop_order_typeIsNull: 'Tipe pesanan tidak dikenali, periksa tipe produk.',
            shop_order_goodsNotFound: 'Informasi produk tidak ada atau telah dihapus.',
            shop_order_giftNotForSale: 'Produk hadiah tidak dapat dibeli langsung.',
            common_message_badRequest: 'Permintaan tidak valid, periksa produk dan parameter.',
        },
    },
    '手机号码最小长度为8位': 'Panjang nomor ponsel minimal 8 digit',
    '邮箱账号名称最小长度为6位': 'Panjang minimal nama akun email adalah 6 karakter',
    '邮箱只能包含英文，数字等字符': 'Kotak surat hanya boleh berisi bahasa Inggris, angka, dan karakter lainnya',
    '请选择正确的收货地址': 'Silakan pilih alamat pengiriman yang benar',
    Dict_language_status_0: 'Nonaktif',
    Dict_language_status_1: 'Aktif',
    Dict_member_label_type_1: 'Label kondisi',
    Dict_member_label_type_2: 'Label manual',
    Dict_member_level_type_0: 'Tingkat konsumsi (LV)',
    Dict_member_level_type_1: 'Anggota berbayar (VIP)',
    Dict_member_growth_action_type_1: 'Buat pesanan',
    Dict_member_growth_action_type_2: 'Login harian',
    Dict_member_growth_action_type_3: 'Tulis ulasan',
    Dict_member_growth_action_type_4: 'Lengkapi profil',
    Dict_paid_member_payment_type_0: 'Pembayaran saldo',
    Dict_paid_member_payment_type_1: 'WeChat Pay',
    Dict_paid_member_payment_type_2: 'Alipay',
    Dict_paid_member_payment_type_3: 'PayPal',
    Dict_paid_member_record_status_0: 'Berlaku',
    Dict_paid_member_record_status_1: 'Kedaluwarsa',
    Dict_paid_member_record_status_2: 'Dikembalikan',
    Dict_point_lottery_prize_type_0: 'Poin',
    Dict_point_lottery_prize_type_1: 'Kupon',
    Dict_point_lottery_prize_type_2: 'Hadiah fisik',
    Dict_point_lottery_prize_type_3: 'Terima kasih telah berpartisipasi',
    Dict_notification_channel_type_0: 'SMS',
    Dict_notification_channel_type_1: 'Email',
    Dict_notification_channel_type_2: 'Pesan internal',
    Dict_notification_channel_type_3: 'Notifikasi push',
    Dict_announcement_status_0: 'Draf',
    Dict_announcement_status_1: 'Diterbitkan',
    Dict_announcement_status_2: 'Ditarik',
    Dict_live_permission_status_0: 'Belum diajukan',
    Dict_live_permission_status_1: 'Sedang ditinjau',
    Dict_live_permission_status_2: 'Diaktifkan',
    Dict_live_permission_status_3: 'Ditolak',
    Dict_live_room_status_0: 'Belum dimulai',
    Dict_live_room_status_1: 'Sedang siaran',
    Dict_live_room_status_2: 'Berakhir',
    Dict_live_room_status_3: 'Gangguan abnormal',
    Dict_live_room_type_0: 'Siaran platform',
    Dict_live_room_type_1: 'Siaran penjual',
    Dict_store_type_0: 'Toko pribadi',
    Dict_store_type_1: 'Toko perusahaan',
    Dict_store_sign_status_0: 'Menunggu tanda tangan',
    Dict_store_sign_status_1: 'Sudah ditandatangani',
    Dict_store_sign_status_2: 'Diputus',
    Dict_store_business_change_status_0: 'Menunggu peninjauan',
    Dict_store_business_change_status_1: 'Disetujui',
    Dict_store_business_change_status_2: 'Ditolak',
    Dict_decoration_page_type_0: 'Beranda',
    Dict_decoration_page_type_1: 'Halaman kategori',
    Dict_decoration_page_type_2: 'Halaman kampanye',
    Dict_decoration_page_type_3: 'Halaman kustom',
    Dict_decoration_status_0: 'Draf',
    Dict_decoration_status_1: 'Diterbitkan',
    Dict_decoration_popup_trigger_page_0: 'Beranda platform',
    Dict_decoration_popup_trigger_page_1: 'Pusat anggota',
    Dict_decoration_popup_trigger_page_2: 'Pembayaran berhasil',
    Dict_decoration_popup_target_user_0: 'Semua pengguna',
    Dict_decoration_popup_target_user_1: 'Anggota gratis',
    Dict_decoration_popup_target_user_2: 'Anggota berbayar',
    Dict_decoration_popup_frequency_0: 'Sekali selamanya',
    Dict_decoration_popup_frequency_1: 'Setiap kunjungan',
    Dict_decoration_popup_frequency_2: 'Frekuensi kustom',
    Dict_track_event_type_page_view: 'Tampilan halaman',
    Dict_track_event_type_click: 'Klik',
    Dict_track_event_type_add_to_cart: 'Tambah ke keranjang',
    Dict_track_event_type_search: 'Pencarian',
    Dict_track_event_type_purchase: 'Pembelian',
    Dict_track_event_type_live_watch: 'Tonton siaran',
    Dict_reconcile_period_type_0: 'Harian',
    Dict_reconcile_period_type_1: 'Mingguan',
    Dict_reconcile_period_type_2: 'Bulanan',
    Dict_store_settlement_status_0: 'Menunggu penyelesaian',
    Dict_store_settlement_status_1: 'Diselesaikan',
    Dict_distributor_status_0: 'Menunggu peninjauan',
    Dict_distributor_status_1: 'Ditinjau',
    Dict_distributor_status_2: 'Ditolak',
    Dict_distribution_commission_type_0: 'Komisi langsung',
    Dict_distribution_commission_type_1: 'Komisi tidak langsung',
    Dict_configuration_status_0: 'Nonaktif',
    Dict_configuration_status_1: 'Aktif',
    ...idLocale
}
export default id